import { jsxs as o, jsx as r } from "react/jsx-runtime";
import { CircleExclamation as s } from "../../components/Icons/index.js";
import '../../assets/index31.css';const c = "ErrorMessage-module__error___0htVr", t = {
  error: c
}, l = ({ error: e }) => /* @__PURE__ */ o("div", { className: t.error, children: [
  /* @__PURE__ */ r(s, { size: 12 }),
  /* @__PURE__ */ r("p", { children: e })
] });
export {
  l as ErrorMessage
};
